// extracted by mini-css-extract-plugin
export default {"ticket":"Ticket_ticket__zLX1t","ticket--shape-minus":"Ticket_ticket--shape-minus__Z6CTG","ticket__vertical":"Ticket_ticket__vertical__hSVhG"};